// Free plan limits
export const BILLING_LIMIT_BOARD_SECTIONS = 0;

export const BILLING_LIMIT_BOARDS = 6;

export const BILLING_LIMIT_INTEGRATIONS = 4;

export const BILLING_LIMIT_DOCS = 25;
